export default __webpack_public_path__ + "static/media/metatrippy.fc28a148.png";